import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

import { addPortalTranslations } from '@repo/settings';
import en from './locales/en.json';
import ar from './locales/ar.json';

addPortalTranslations({ en, ar });

createRoot(document.getElementById('root')!).render(<App />);
